//
// Generated class OnlineOrder
//

/// <reference path="OnlineOrder_ManagedObject.ts" />

class OnlineOrder extends OnlineOrder_ManagedObject
{
}
